(function () {
  'use strict';

  const config = window.CUSTOM_GWP_CONFIG;
  if (!config || !Array.isArray(config.rules) || config.rules.length === 0) {
    return;
  }

  const RULES = config.rules;
  const SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  let internalCall = false;
  let syncRunning = false;
  const activeRules = new Set();

  const isGift = (item) =>
    item.properties && item.properties._gwp === 'true';

  async function cartFetch(url, body) {
    internalCall = true;
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      return res.ok ? res.json() : null;
    } finally {
      internalCall = false;
    }
  }

  async function getCart() {
    internalCall = true;
    try {
      const res = await fetch('/cart.js');
      return res.json();
    } finally {
      internalCall = false;
    }
  }

  async function addSingleGift(variantId) {
    return cartFetch('/cart/add.js', {
      items: [{ id: variantId, quantity: 1, properties: { _gwp: 'true' } }],
    });
  }

  async function removeGiftItems(giftItems) {
    if (giftItems.length === 0) return null;
    const updates = {};
    giftItems.forEach((item) => {
      updates[item.key] = 0;
    });
    return cartFetch('/cart/update.js', {
      updates,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
  }

  async function refreshSections() {
    const data = await cartFetch('/cart/update.js', {
      updates: {},
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
    refreshCartUI(data);
  }

  function refreshCartUI(data) {
    if (!data || !data.sections) return;
    SECTIONS.forEach((sectionId) => {
      const element = document.getElementById(sectionId);
      const html = data.sections[sectionId];
      if (!element || !html) return;
      try {
        element.innerHTML = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section').innerHTML;
      } catch (e) {}
    });
  }

  function optimisticHideGifts() {
    document.querySelectorAll('input[name*="properties[_gwp]"], input[name*="_gwp"]').forEach((input) => {
      const row = input.closest(
        '[data-line-item], [data-cart-item], .cart-item, .cart__row, cart-drawer-item, tr[data-key], li[data-key]'
      );
      if (row) {
        row.style.transition = 'opacity 0.15s';
        row.style.opacity = '0.3';
        row.style.pointerEvents = 'none';
      }
    });
  }

  function ruleGiftsInCart(cart, rule) {
    return cart.items.filter(
      (i) => isGift(i) && rule.giftVariantIds.includes(i.variant_id)
    );
  }

  async function syncGifts(cartData) {
    if (syncRunning) return;
    syncRunning = true;

    try {
      const cart = cartData || (await getCart());
      const toRemove = [];
      let changed = false;

      const protectedVariants = new Set();
      for (const rule of RULES) {
        const hasTrigger = cart.items.some((i) => i.product_id === rule.triggerProductId);
        if (hasTrigger) rule.giftVariantIds.forEach((id) => protectedVariants.add(id));
      }

      for (const rule of RULES) {
        const hasTrigger = cart.items.some((i) => i.product_id === rule.triggerProductId);
        const ruleGifts = ruleGiftsInCart(cart, rule);
        const hasGifts = ruleGifts.length > 0;

        if (hasTrigger && !hasGifts && !activeRules.has(rule.triggerProductId)) {
          for (const id of rule.giftVariantIds) {
            await addSingleGift(id);
          }
          activeRules.add(rule.triggerProductId);
          changed = true;
        } else if (!hasTrigger && hasGifts) {
          ruleGifts.forEach((item) => {
            if (!protectedVariants.has(item.variant_id)) toRemove.push(item);
          });
          activeRules.delete(rule.triggerProductId);
          changed = true;
        } else if (hasGifts) {
          activeRules.add(rule.triggerProductId);
        } else if (!hasTrigger && !hasGifts) {
          activeRules.delete(rule.triggerProductId);
        }
      }

      if (toRemove.length > 0) {
        const seen = {};
        const unique = toRemove.filter((i) => (seen[i.key] ? false : (seen[i.key] = true)));
        const data = await removeGiftItems(unique);
        if (data) {
          refreshCartUI(data);
          return;
        }
      }

      if (changed) {
        await refreshSections();
      }
    } catch (e) {} finally {
      syncRunning = false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const wasInternal = internalCall;

    const isCartMutation = !wasInternal && /\/cart\/(add|change|update)/.test(url);
    const isRemoval = !wasInternal && /\/cart\/(change|update)/.test(url);

    if (isRemoval) {
      optimisticHideGifts();
    }

    const response = await originalFetch.apply(this, args);

    if (isCartMutation) {
      const isAdd = /\/cart\/add/.test(url);
      try {
        const cloned = response.clone();
        const data = await cloned.json();
        if (data && Array.isArray(data.items)) {
          setTimeout(() => syncGifts(data), isAdd ? 600 : 0);
        } else {
          setTimeout(() => syncGifts(), isAdd ? 600 : 0);
        }
      } catch (e) {
        setTimeout(() => syncGifts(), isAdd ? 600 : 0);
      }
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', () => setTimeout(syncGifts, 300));
})();
